import React, { useState } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import scssVariables from 'styles/variables.module.scss';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { ItemProps, SideMenu } from 'components/common/SideMenu/SideMenu';
import { ReportingSideMenu } from 'components/common/reportingSideMenu/ReportingSideMenu';

import Button from 'components/DesignSystem/Button/Button';

import classes from './responsive.module.scss';

interface Props {
    children: React.ReactNode;
    sideMenu?: ItemProps[];
    isReporting?: boolean;
    title?: string;
}

export const Responsive = ({ children, sideMenu = [], title = '', isReporting }: Props) => {
    const { mediaLaptop } = scssVariables;
    const matches = useMediaQuery(`(max-width: ${mediaLaptop})`);
    const [collapse, setCollapse] = useState(false);
    const showTooltip = collapse || matches;

    return (
        <div className={classes.container}>
            {isReporting ? (
                <ReportingSideMenu />
            ) : (
                sideMenu.length > 0 && (
                    <div className={`${classes.leftSide} ${showTooltip && classes.collapse}`}>
                        <div className={classes.collapseIcon}>
                            <Button
                                id={`LeftPanelMenu${collapse ? 'Close' : 'Open'}`}
                                variant={'tertiary'}
                                onClick={() => !matches && setCollapse(!collapse)}
                            >
                                <MuiIcon
                                    icon={'keyboard_double_arrow_left'}
                                    fontSize={'24px'}
                                    color={'var(--button-tertiary-fg'}
                                />
                            </Button>
                        </div>
                        <SideMenu menu={sideMenu} title={title} collapse={showTooltip} />
                    </div>
                )
            )}
            <div className={classes.rightSide}>{children}</div>
        </div>
    );
};
